<!-- @format -->
<script>
  import { slide } from "svelte/transition";
  export let open_by_default = false;
  $: isOpen = open_by_default;
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div on:click|stopPropagation={() => (isOpen = !isOpen)}>
  {#if isOpen}
    <slot name="open" />
  {:else}
    <slot name="close" />
  {/if}
</div>

{#if isOpen}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div transition:slide on:click|stopPropagation={() => (isOpen = !isOpen)}>
    <slot/>
  </div>
{/if}
